import { createFileRoute } from "@tanstack/react-router"
import { SignupEmailChangePage } from "@/pages/onboarding"

export const Route = createFileRoute("/onboarding/signup-email-change")({
	component: SignupEmailChangePage,
})
